export interface SocialPost {
  id: number;
  title: string;
  content: string;
  status: string;
  status_display?: string;
  post_type: string;
  scheduled_time: string | null;
  published_time?: string | null;
  error_message?: string;
  platforms_detail?: Array<{
    id: number;
    platform: string;
    account_name: string;
    platform_display: string;
  }>;
  media_detail?: Array<{
    id: number;
    name?: string;
    file?: string;
    thumbnail_url?: string;
  }>;
  production_photos_detail?: Array<{
    id: number;
    image_url?: string;
    thumbnail_url?: string;
  }>;
  platform_content?: {
    delivery?: Record<
      string,
      { status: string; error?: string; updated_at?: string }
    >;
    published_ids?: Record<string, string>;
  };
}
export interface SocialFilters {
  search: string;
  status: string;
  platform: string;
  account: string;
  post_type: string;
  start_date: string;
  end_date: string;
}
export const emptySocialFilters: SocialFilters = {
  search: "",
  status: "",
  platform: "",
  account: "",
  post_type: "",
  start_date: "",
  end_date: "",
};
